import {getLoanOwnStatusTextByValue} from "./ownLoanUtility";
import {isNullOrUndefined} from "../../../../Utilities/commonUtilities";
import {convertDateToPrintString} from "../../../../Utilities/Types/dateUtilities";
import type { OwnLoanItem } from './ownLoan.types';

export const ownLoanItemModel = ({
                                     ownLoanItemId,
                                     ownLoanStatus,
                                     ownLoanNotes,
                                     dateCreatedUtc,
                                     dateFulfilled,
                                     dateFulfilledUtc,
                                     ownCatalogItemId,
                                     ownCatalogNumber,
                                     ownCatalogItemTitle,
                                     ownCatalogItemCost,
                                     quantity,
                                     ownQueueItemId,
                                     patronFullName,
                                     patronSubType,
                                     patronEmail,
                                     districtName,
                                     organization,
                                     shippingLocation,
                                     shippingLocationName
                                 }: Record<string, any> = {}): OwnLoanItem => ({


    ownLoanItemId,
    ownLoanStatus,
    ownLoanStatusText: getLoanOwnStatusTextByValue(ownLoanStatus),
    ownLoanNotes: isNullOrUndefined(ownLoanNotes) ? "" : ownLoanNotes,
    dateCreatedUtc,
    dateCreatedFormatted: convertDateToPrintString(dateCreatedUtc),
    dateFulfilled,
    dateFulfilledUtc,
    ownCatalogItemId,
    ownCatalogNumber,
    ownCatalogItemTitle,
    ownCatalogItemCost,
    quantity: quantity ?? 1,
    ownQueueItemId,
    patronFullName,
    patronSubType,
    patronEmail,
    districtName,
    organization,
    shippingLocation,
    shippingLocationName
});

export const updateOwnLoanItemModel = ({
                                     ownLoanItemId,
                                     ownLoanStatus,
                                     ownLoanNotes,
                                 }: Partial<OwnLoanItem> = {}) => ({


    ownLoanItemId,
    ownLoanStatus,
    ownLoanNotes
});
